class LazyloadImage {
  private lazyloadElement: NodeListOf<HTMLElement>;

  constructor() {
    this.lazyloadElement =
      document.querySelectorAll<HTMLElement>('[data-lazyload]');
    this.init();
  }

  private init(): void {
    if (this.lazyloadElement) {
      this.lazyloadElement.forEach((item) => {
        if (item.hasAttribute('data-lazyload-autostart')) {
          this.loadImages(item);
        }
      });
    }

    document.addEventListener('visible', (event: Event) => {
      const target = event.target as HTMLElement;
      if (target && target.getAttribute('data-lazyload-src')) {
        this.loadImages(target);
      }
    });
  }

  private loadImages(element: HTMLElement): void {
    const imageURL = element.getAttribute('data-lazyload-src');
    if (!imageURL) return;

    const image = new Image();
    image.src = imageURL;
    image.onload = () => {
      if (element.nodeName.toLowerCase() === 'img') {
        element.setAttribute('src', imageURL);
      } else {
        element.style.backgroundImage = `url(${imageURL})`;
      }
      element.setAttribute('data-lazyload-state', 'loaded');
    };
  }
}

export const lazyloadImage = new LazyloadImage();
